import { I18n } from 'lib/i18n'
import { get } from 'lib/utilities'
import { toast } from 'react-toastify'

export const LOAD = 'keywords/LOAD'
export const LOAD_DONE = 'keywords/LOAD_DONE'
export const LOAD_FAILED = 'keywords/LOAD_FAILED'
export const ADD = 'keywords/ADD'

export const loadKeywords = () => ({ type: LOAD })
export const loadFulfilled = (keywords) => ({ type: LOAD_DONE, keywords })
export const loadFailed = (errors) => ({ type: LOAD_FAILED, errors })

const initialState = {
  keywords: { de: [], fr: [] },
}

export const keywordReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD:
      return { ...state }
    case LOAD_DONE:
      return { ...state, keywords: action.keywords }
    default:
      return state
  }
}

export const loadEpic = (action$, store) =>
  action$
    .ofType(LOAD)
    .mergeMap((action) => get('/keywords.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadFulfilled(result.body)]
      } else {
        toast.error(I18n.t(`action.${LOAD_FAILED}`))
        return [loadFailed(result.body.errors)]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/keywords.js